import React, { useEffect, useRef } from "react";

// 產品介紹區元件 - 簡述 Vapor 是什麼（帶滾動動畫）
const Intro = ({ t }) => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.unobserve(el);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="intro scroll-reveal" ref={ref}>
      <div className="container">
        <h2>{t.intro.title}</h2>
        <p>{t.intro.description}</p>
      </div>
    </section>
  );
};

export default Intro;
